/**
* Locations JS
* -----------------------------------------------------------------------------
*
* All the JS for the Locations component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'locations',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const mobileToggle = document.getElementById( 'mobile-dropdown-toggle' );
      const tabContainer = document.getElementById( 'tab-container' );
      const selectedTabTitle = document.getElementById( 'selected-tab-title' );

      // Mobile dropdown functionality
      if ( mobileToggle && tabContainer ) {
        mobileToggle.addEventListener( 'click', function() {
          if ( window.innerWidth < 768 ) {
            tabContainer.classList.toggle( 'hidden' );
          }
        } );

        tabContainer.querySelectorAll( 'button' ).forEach( ( button ) => {
          button.addEventListener( 'click', () => {
            selectedTabTitle.textContent = button.textContent.trim();
            if ( window.innerWidth < 768 ) {
              tabContainer.classList.add( 'hidden' );
            }

            // Recalculate hover effects when tabs change
            setTimeout( () => {
              this.updateHoverEffects();
            }, 50 );
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'locations', COMPONENT );
} )( app );
